// <s-copy-code> — copies its data-code to the clipboard when its button runs the --copy command.
// Swaps the button label to the "copied" text briefly and announces it politely.
class SCopyCode extends HTMLElement {
  #ac = null;
  #resetTimer = null;
  #raf = 0;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener("command", (event) => this.#onCommand(event), { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
    window.clearTimeout(this.#resetTimer);
    cancelAnimationFrame(this.#raf);
  }

  async #onCommand(event) {
    if (event.command !== "--copy") return;
    const code = this.dataset.code || "";
    const label = this.querySelector("[data-copy-label]");
    const status = this.querySelector("[data-copy-status]");
    try {
      if (typeof navigator.clipboard?.writeText === "function") {
        await navigator.clipboard.writeText(code);
      }
    } catch (_error) {
      return;
    }
    if (label) label.textContent = this.dataset.copiedText || "";
    if (status) {
      cancelAnimationFrame(this.#raf);
      status.textContent = "";
      this.#raf = requestAnimationFrame(() => {
        status.textContent = this.dataset.copiedText || "";
      });
    }
    window.clearTimeout(this.#resetTimer);
    this.#resetTimer = window.setTimeout(() => {
      if (label) label.textContent = this.dataset.copyText || "";
    }, 2000);
  }
}

if (!customElements.get("s-copy-code")) {
  customElements.define("s-copy-code", SCopyCode);
}
